import { combineReducers } from 'redux';

import { ImportJob, ImportJobMessage } from 'entities/consentImport';
import { IP } from 'entities/ip';
import { User } from 'entities/user';
import { GenericAction, genericReducer, GenericState, RestApiId } from 'services/genericAPIGatewayService';

import { Action as AuthAction, reducer as authReducer, State as AuthState } from './authentication';
import { Service as ConsentImportService } from './consentImportJobs/services';
import {
  Action as LaunchDarklyAction,
  reducer as launchDarklyReducer,
  State as LaunchDarklyState,
} from './launchDarkly';
import { Service as UsersService } from './users';

export interface DataState {
  auth: AuthState;
  consentImportJobsBySite: GenericState<ImportJob>;
  consentImportJobsByBrand: GenericState<ImportJob>;
  consentImportJobMessages: GenericState<ImportJobMessage>;
  ipBlacklist: GenericState<IP>;
  launchDarkly: LaunchDarklyState;
  users: GenericState<User>;
}

export type DataAction =
  | AuthAction
  | GenericAction<IP, RestApiId.IP_BLACKLIST>
  | LaunchDarklyAction
  | GenericAction<User, UsersService.Users>
  | GenericAction<ImportJob, ConsentImportService.JobByBrand>
  | GenericAction<ImportJob, ConsentImportService.JobBySite>
  | GenericAction<ImportJobMessage, ConsentImportService.Messages>;

export const dataReducer = combineReducers({
  auth: authReducer,
  consentImportJobsByBrand: genericReducer<ImportJob, ConsentImportService.JobByBrand>(ConsentImportService.JobByBrand),
  consentImportJobsBySite: genericReducer<ImportJob, ConsentImportService.JobBySite>(ConsentImportService.JobBySite),
  consentImportJobMessages: genericReducer<ImportJobMessage, ConsentImportService.Messages>(
    ConsentImportService.Messages,
  ),
  ipBlacklist: genericReducer<IP, RestApiId.IP_BLACKLIST>(RestApiId.IP_BLACKLIST),
  launchDarkly: launchDarklyReducer,
  users: genericReducer<User, UsersService.Users>(UsersService.Users),
});
